<template>
	<div class="v-modal-alignment" @click.self="$vmodal.dismissViaBackgroundClick()">
		<Transition
			:name="$vmodal.options.animation" mode="out-in">
			<Component
				:is="$vmodal.options.component"
				class="v-modal"
				v-bind="$vmodal.options.props"/>
		</Transition>
	</div>
</template>
<script>
export default {
	mounted() {
		this.watchKey("Escape", () => {
			this.$vmodal.dismissViaEscape();
		});
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.scaleBottom-enter-active,
.scaleBottom-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
	transform: scale(1);
}

.scaleBottom-enter,
.scaleBottom-leave-to {
	transform: scale(0);
	opacity: 0;
	transform-origin: bottom center;
}

.scaleIn-enter-active,
.scaleIn-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	transform: scale(1);
}

.scaleIn-enter,
.scaleIn-leave-to {
	opacity: 0;
	transform: scale(1.23);
}

.scaleLeft-enter-active,
.scaleLeft-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
	transform: scale(1);
}

.scaleLeft-enter,
.scaleLeft-leave-to {
	transform: scale(0);
	opacity: 0;
	transform-origin: left center;
}

.scaleOut-enter-active,
.scaleOut-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	transform: scale(1);
}

.scaleOut-enter,
.scaleOut-leave-to {
	opacity: 0;
	transform: scale(0.5);
}

.scaleRight-enter-active,
.scaleRight-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
	transform: scale(1);
}

.scaleRight-enter,
.scaleRight-leave-to {
	transform: scale(0);
	opacity: 0;
	transform-origin: right center;
}

.scaleTop-enter-active,
.scaleTop-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
	transform: scale(1);
}

.scaleTop-enter,
.scaleTop-leave-to {
	transform: scale(0);
	opacity: 0;
	transform-origin: top center;
}

.slideBottom-enter-active,
.slideBottom-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
}

.slideBottom-enter,
.slideBottom-leave-to {
	transform: translateY(70px);
	opacity: 0;
}

.slideLeft-enter-active,
.slideLeft-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
}

.slideLeft-enter,
.slideLeft-leave-to {
	transform: translateX(-70px);
	opacity: 0;
}

.slideRight-enter-active,
.slideRight-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
}

.slideRight-enter,
.slideRight-leave-to {
	transform: translateX(70px);
	opacity: 0;
}

.slideTop-enter-active,
.slideTop-leave-active {
	transition-property: all;
	transition-duration: 0.32s;
	transition-timing-function: cubic-bezier(0.63, 0.14, 0.09, 1.02);
	transition-delay: 0s;
	opacity: 1;
}

.slideTop-enter,
.slideTop-leave-to {
	transform: translateY(-70px);
	opacity: 0;
}
</style>
